var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 47,
    viewBox: "0 0 28 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39844 10.0539C7.39844 11.6023 7.58011 13.0404 7.77828 14.5691C7.99308 16.2261 7.94982 17.9544 7.94982 19.6234C7.94982 22.742 7.99302 25.8723 7.83342 28.9846C7.5783 33.9593 7.50871 38.9218 7.50871 43.9087",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8457 2.33453C6.8457 2.53051 6.87634 2.61635 6.95598 2.77564",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35279 10.2147C2.35279 11.4904 2.60907 12.8327 2.84904 14.0805C3.11745 15.4763 3.10188 17.1517 2.92868 18.559C2.67495 20.6205 2.69797 22.7526 2.57947 24.8263C2.43737 27.3131 2.57335 29.8532 2.57335 32.3435C2.57335 35.6521 2.57947 41.4094 2.57947 44.7222C2.68362 45.8479 2.68362 43.718 2.68362 43.2976C2.68362 42.6134 2.68362 41.9293 2.68362 41.2452C2.68362 38.6807 2.25163 36.1437 2.35892 33.5688C2.42617 31.9548 2.72428 30.3892 2.95931 28.7963C3.21104 27.0901 3.4139 25.3969 3.59034 23.6807C3.73634 22.2605 4.07535 20.8336 4.33776 19.4289C4.62011 17.9175 4.81836 16.3383 5.4344 14.9137C6.24382 13.0419 7.64473 11.6318 9.66778 11.2072C10.793 10.971 12.0271 11.0969 13.1721 11.0969C14.5499 11.0969 15.7459 11.1772 17.0685 11.5993C19.4947 12.3736 21.2817 14.7487 22.2638 16.9783C23.4256 19.6161 23.8185 22.2867 24.1385 25.1204C24.8235 31.1878 25.6211 37.293 25.6211 43.4078",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.7498c05c53e73d84e9d0b6b7e8f8d1d0.svg";
export { ForwardRef as ReactComponent };